import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { EBAY, EMAIL, PAY_METHODS, PHONE, TYPES, waLink } from "../../lib/api";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#06090D]">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-8 md:grid-cols-12 lg:px-12">
      <div className="md:col-span-5">
        <LogoMark className="h-12 w-12" />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
          Replacement airbags, seat belts and SRS parts. Every listing shows its part number, photos and stock so you can buy
          with confidence.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Shop</p>
        <ul className="mt-4 space-y-2 text-sm">
          {TYPES.slice(0, 6).map((t) => (
            <li key={t.value}>
              <Link to={`/shop?type=${t.value}`} className="text-slate-300 hover:text-white">
                {t.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-4">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Talk to us</p>
        <ul className="mt-4 space-y-3 text-sm">
          <li><a data-testid="footer-phone-link" href={`tel:${PHONE}`} className="text-slate-200 hover:text-white">Call {PHONE}</a></li>
          <li><a data-testid="footer-whatsapp-link" href={waLink()} target="_blank" rel="noreferrer" className="text-slate-200 hover:text-white">WhatsApp {PHONE}</a></li>
          <li><a data-testid="footer-email-link" href={`mailto:${EMAIL}`} className="break-all text-slate-200 hover:text-white">{EMAIL}</a></li>
          <li><a data-testid="footer-ebay-link" href={EBAY} target="_blank" rel="noreferrer" className="text-[#F59E0B] hover:text-white">Visit our eBay shop ↗</a></li>
        </ul>
        <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">We accept</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {PAY_METHODS.map((m) => (
            <span key={m} className="rounded-full border border-white/15 px-3 py-1 text-xs text-slate-200">{m}</span>
          ))}
        </div>
      </div>
    </div>
    <div className="pointer-events-none select-none px-4 font-display text-[22vw] font-black uppercase leading-[0.8] tracking-tighter text-white/[0.04] sm:px-8">
      CBLS
    </div>
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 border-t border-white/10 px-4 py-6 font-mono text-xs text-slate-400 sm:px-8 lg:px-12">
      <span>© {new Date().getFullYear()} CBLS AIRBAGS. Prices in GBP.</span>
      <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
    </div>
  </footer>
);
